import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApiServices } from 'api';
import { AppDispatch, RootState } from 'redux/store';

export interface ThunkExtraArg {
  api: typeof ApiServices;
}

export const createAppAsyncThunk = createAsyncThunk.withTypes<{
  state: RootState;
  dispatch: AppDispatch;
  rejectValue: string;
  extra: ThunkExtraArg;
}>();
